export const OmniScanOverlayManager = (function () {

  const SENSOR_OVERLAY = "omniscan-sensors";
  const GAUSSIAN_OVERLAY = "omniscan-gaussian";

  function resolveTHREE(viewer) {
    if (window.THREE) return window.THREE;
    if (viewer && viewer.impl && viewer.impl.THREE) return viewer.impl.THREE;
    return null;
  }

  function ensureOverlay(viewer, name) {
    try { viewer.impl.createOverlayScene(name); } catch (e) {}
  }

  function clearOverlay(viewer, name) {
    try { viewer.impl.removeOverlayScene(name); } catch (e) {}
  }

  /* ===========================
     SENSOR DOTS
  ============================ */

  function addRandomSensors(viewer, count = 180) {
    clearOverlay(viewer, SENSOR_OVERLAY);
    ensureOverlay(viewer, SENSOR_OVERLAY);

    const THREE = resolveTHREE(viewer);
    if (!THREE) {
      console.warn("FORGE: THREE not available for sensors");
      return;
    }

    const bounds = viewer.model.getBoundingBox();
    const pulseMeshes = [];
    let animationActive = true;

    for (let i = 0; i < count; i++) {
      const x = bounds.min.x + Math.random() * (bounds.max.x - bounds.min.x);
      const y = bounds.min.y + Math.random() * (bounds.max.y - bounds.min.y);
      const z = bounds.min.z + Math.random() * (bounds.max.z - bounds.min.z);

      const isFault = Math.random() > 0.85;
      const color = isFault ? 0xff3333 : 0x33ff66;

      /* Core */
      const coreGeo = new THREE.SphereGeometry(0.45, 12, 12);
      const coreMat = new THREE.MeshBasicMaterial({ color: color });
      const coreMesh = new THREE.Mesh(coreGeo, coreMat);
      coreMesh.position.set(x, y, z);
      viewer.impl.addOverlay(SENSOR_OVERLAY, coreMesh);

      /* Only FAULT sensors pulse */
      if (isFault) {
        const pulseGeo = new THREE.SphereGeometry(0.6, 12, 12);
        const pulseMat = new THREE.MeshBasicMaterial({
          color: color,
          transparent: true,
          opacity: 0.5,
          depthWrite: false
        });

        const pulseMesh = new THREE.Mesh(pulseGeo, pulseMat);
        pulseMesh.position.set(x, y, z);
        pulseMesh.userData = {
          scale: 1.0,
          speed: 0.025
        };

        viewer.impl.addOverlay(SENSOR_OVERLAY, pulseMesh);
        pulseMeshes.push(pulseMesh);
      }
    }

    /* Animate FAULT pulses only */
	function animate() {
	  if (!animationActive) return;
	  if (!viewer || !viewer.impl) return;

	  for (let i = 0; i < pulseMeshes.length; i++) {
	    const p = pulseMeshes[i];

	    if (!p || !p.material) continue;

	    p.userData.scale += p.userData.speed;

	    p.scale.x = p.userData.scale;
	    p.scale.y = p.userData.scale;
	    p.scale.z = p.userData.scale;

	    p.material.opacity = Math.max(0, 0.6 - (p.userData.scale - 1.0));

	    if (p.userData.scale > 2.6) {
	      p.userData.scale = 1.0;
	      p.material.opacity = 0.6;
	    }
	  }

	  try {
	    viewer.impl.invalidate(true);
	  } catch (e) {}

	  requestAnimationFrame(animate);
	}


    animate();

    viewer._omniscanStopPulse = function () {
      animationActive = false;
    };
  }




  function clearSensors(viewer) {
    clearOverlay(viewer, SENSOR_OVERLAY);
    viewer.impl.invalidate(true);
  }

  /* ===========================
     RAG CONDITION THEMING
  ============================ */

  function applyRAG(viewer) {
    const THREE = resolveTHREE(viewer);
    if (!THREE) {
      console.warn("FORGE: THREE not available for RAG");
      return;
    }

    const model = viewer.model;
    const tree = model.getInstanceTree();

    model.clearThemingColors();

    tree.enumNodeChildren(tree.getRootId(), function (dbId) {
      const r = Math.random();
      let color;

      if (r < 0.2) color = new THREE.Vector4(1, 0, 0, 0.7);
      else if (r < 0.5) color = new THREE.Vector4(1, 0.65, 0, 0.7);
      else color = new THREE.Vector4(0, 1, 0, 0.7);

      model.setThemingColor(dbId, color);
    }, true);

    viewer.setGhosting(true);
    viewer.impl.invalidate(true);
  }

  function clearRAG(viewer) {
    try { viewer.model.clearThemingColors(); } catch (e) {}
    viewer.impl.invalidate(true);
  }

  /* ===========================
     GAUSSIAN HEATMAP
  ============================ */

  function createGaussianHeatmap(viewer, density = 140) {
    clearOverlay(viewer, GAUSSIAN_OVERLAY);
    ensureOverlay(viewer, GAUSSIAN_OVERLAY);

    const THREE = resolveTHREE(viewer);
    if (!THREE) {
      console.warn("FORGE: THREE not available for gaussian");
      return;
    }

    const bounds = viewer.model.getBoundingBox();

    const cx = (bounds.min.x + bounds.max.x) / 2;
    const cy = (bounds.min.y + bounds.max.y) / 2;
    const cz = (bounds.min.z + bounds.max.z) / 2;

    const sx = bounds.max.x - bounds.min.x;
    const sy = bounds.max.y - bounds.min.y;
    const sz = bounds.max.z - bounds.min.z;

    for (let i = 0; i < density; i++) {
      const px = cx + randomGaussian() * sx * 0.15;
      const py = cy + randomGaussian() * sy * 0.15;
      const pz = cz + randomGaussian() * sz * 0.15;

      const geometry = new THREE.SphereGeometry(6.5, 16, 16);
      const material = new THREE.MeshBasicMaterial({
        color: 0x995500,
        transparent: true,
        opacity: 0.38,
        depthWrite: false
      });

      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(px, py, pz);

      viewer.impl.addOverlay(GAUSSIAN_OVERLAY, mesh);
    }

    viewer.impl.invalidate(true);
  }

  function clearGaussian(viewer) {
    clearOverlay(viewer, GAUSSIAN_OVERLAY);
    viewer.impl.invalidate(true);
  }

  /* ===========================
     CLEAR ALL
  ============================ */

  function clearAll(viewer) {
    clearSensors(viewer);
    clearGaussian(viewer);
    clearRAG(viewer);
  }

  /* ===========================
     UTILS
  ============================ */

  function randomGaussian() {
    let u = 0, v = 0;
    while (u === 0) u = Math.random();
    while (v === 0) v = Math.random();
    return Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
  }

  return {
    addRandomSensors,
    clearSensors,
    applyRAG,
    clearRAG,
    createGaussianHeatmap,
    clearGaussian,
    clearAll
  };

})();
